/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { getVehicleAssessmentDashBoardData } from "../fetchData";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate } from "react-router-dom";
import { ROLES } from "../../../../util/roleNameConstants";
import HsDashBoardCardBG from "../../../../assets/images/hs-dashboard-card-bg.png";

const VehicleAssessmentDashboard = ({ date, setDate }: any) => {
  const toast = useRef<Toast>(null);
  const navigate = useNavigate();

  const [teamsList, setTeamsList] = useState<any>([]);
  const [VehicleAssessmentDashBoardData, setVehicleAssessmentDashBoardData] =
    useState<any>([]);
  const [
    VehicleAssetDashBoardDataLoading,
    setVehicleAssetDashBoardDataLoading,
  ] = useState<boolean>(false);

  const [selectedTeam, setSelectedTeam] = useState<string | null>("All Teams");

  useEffect(() => {
    if (!localStorage.roleName?.includes(ROLES.HANDS_ADMIN)) {
      navigate(localStorage.currentModuleUrl || "/");
    }
  }, []);

  useEffect(() => {
    getVehicleAssessmentDashBoardData(
      setVehicleAssessmentDashBoardData,
      setVehicleAssetDashBoardDataLoading,
      date,
      toast
    );
  }, [date]);

  const submittedVehicles = VehicleAssessmentDashBoardData.filter(
    (v: any) => v.isSubmitted
  );
  const notSubmittedVehicles = VehicleAssessmentDashBoardData.filter(
    (v: any) => !v.isSubmitted
  );

  const handleCardClick = (teamName: string) => {
    setSelectedTeam(teamName);
  };

  let showSubmitted = submittedVehicles;
  let showNotSubmitted = notSubmittedVehicles;

  if (selectedTeam === "Submitted") {
    showSubmitted = submittedVehicles;
    showNotSubmitted = [];
  } else if (selectedTeam === "NotSubmitted") {
    showSubmitted = [];
    showNotSubmitted = notSubmittedVehicles;
  } else if (selectedTeam === "All Teams") {
    showSubmitted = submittedVehicles;
    showNotSubmitted = notSubmittedVehicles;
  }

  return (
    <>
      <Toast ref={toast} />
      <div className="tw-space-y-6">
        {/* Dashboard Header */}
        <div className="tw-w-full">
          {/* Mobile layout (stacked) */}
          <div className="tw-flex tw-flex-col tw-gap-4 md:tw-hidden tw-mb-6">
            <div>
              <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800">
                Risk Assessment Dashboard
              </h1>
              <p className="tw-text-gray-500">
                Team submission status overview
              </p>
            </div>
          </div>

          {/* Desktop layout (side by side) */}
          <div className="tw-hidden md:tw-flex tw-justify-between tw-items-start tw-mb-6">
            <div></div>
          </div>
        </div>
        {/* Summary Cards */}
        <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-5 tw-gap-4">
          {/* All Teams Card */}
          <div
            className={`tw-border tw-rounded-lg tw-p-4 tw-cursor-pointer tw-transition-all ${
              selectedTeam === "All Teams"
                ? "tw-border-blue-500 tw-bg-blue-50"
                : "tw-border-gray-200 hover:tw-bg-gray-50"
            }`}
            onClick={() => handleCardClick("All Teams")}
            style={{
              backgroundImage: `url(${HsDashBoardCardBG})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="tw-mt-2 tw-flex tw-justify-between">
              <div className="tw-flex tw-flex-col">
                <h2 className="tw-font-medium tw-text-lg tw-text-gray-900">
                  Total Vehicles
                </h2>
                <p className="tw-text-xl tw-font-bold">
                  {VehicleAssessmentDashBoardData.length}
                </p>
              </div>
            </div>
          </div>

          {/* Submitted Vehicles Card */}
          <div
            className={`tw-border tw-rounded-lg tw-p-4 tw-cursor-pointer tw-transition-all ${
              selectedTeam === "Submitted"
                ? "tw-border-blue-500 tw-bg-blue-50"
                : "tw-border-gray-200 hover:tw-bg-gray-50"
            }`}
            onClick={() => handleCardClick("Submitted")}
            style={{
              backgroundImage: `url(${HsDashBoardCardBG})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="tw-mt-2 tw-flex tw-justify-between">
              <div className="tw-flex tw-flex-col">
                <h2 className="tw-font-medium tw-text-lg tw-text-gray-900">
                  Submitted
                </h2>
                <p className="tw-text-xl tw-font-bold">
                  {submittedVehicles.length}
                </p>
              </div>
              <div className="tw-space-y-1 tw-mt-2"></div>
            </div>
          </div>

          {/* Not Submitted Vehicles Card */}
          <div
            className={`tw-border tw-rounded-lg tw-p-4 tw-cursor-pointer tw-transition-all ${
              selectedTeam === "NotSubmitted"
                ? "tw-border-blue-500 tw-bg-blue-50"
                : "tw-border-gray-200 hover:tw-bg-gray-50"
            }`}
            onClick={() => handleCardClick("NotSubmitted")}
            style={{
              backgroundImage: `url(${HsDashBoardCardBG})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="tw-mt-2 tw-flex tw-justify-between">
              <div className="tw-flex tw-flex-col">
                <h2 className="tw-font-medium tw-text-lg tw-text-gray-900">
                  Not Submitted
                </h2>
                <p className="tw-text-xl tw-font-bold">
                  {notSubmittedVehicles.length}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Team Details */}
        {VehicleAssetDashBoardDataLoading ? (
          <div className="tw-flex tw-justify-center tw-items-center tw-py-8">
            <ProgressSpinner />
          </div>
        ) : (
          <div className="tw-space-y-4">
            <div className="tw-border tw-border-gray-200 tw-rounded-lg tw-overflow-hidden tw-bg-white">
              <div className="tw-p-4 tw-bg-gray-50 tw-sticky tw-top-0 tw-z-10">
                <h3 className="tw-font-medium tw-text-gray-800 tw-text-lg tw-mb-4">
                  {selectedTeam === "All Teams"
                    ? "All Vehicles Summary"
                    : selectedTeam === "Submitted"
                    ? "Submitted Vehicles"
                    : selectedTeam === "NotSubmitted"
                    ? "Not Submitted Vehicles"
                    : "All Vehicles Summary"}
                </h3>
                <div className="tw-flex tw-gap-4 tw-mt-2">
                  {selectedTeam !== "Submitted" && (
                    <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-bg-yellow-100 tw-text-yellow-800">
                      {showNotSubmitted.length} Not Submitted
                    </span>
                  )}
                  {selectedTeam !== "NotSubmitted" && (
                    <span className="tw-inline-flex tw-items-center tw-px-3 tw-py-1 tw-rounded-full tw-text-sm tw-font-medium tw-bg-green-100 tw-text-green-800">
                      {showSubmitted.length} Submitted
                    </span>
                  )}
                </div>
              </div>
              <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-p-4 tw-max-h-[60vh] tw-overflow-y-auto">
                {/* Submitted Vehicles List */}
                {(selectedTeam === "All Teams" ||
                  selectedTeam === "NotSubmitted") && (
                  <div>
                    <div className="tw-space-y-2">
                      {showNotSubmitted.length > 0 ? (
                        showNotSubmitted.map((vehicle: any) => (
                          <div
                            key={vehicle.vehicleID}
                            className="tw-p-2 tw-bg-white tw-rounded tw-shadow-xs tw-border tw-border-yellow-100 tw-flex tw-justify-between tw-items-center tw-min-h-[48px]"
                          >
                            <div>
                              <div className="tw-font-medium tw-text-gray-800">
                                {vehicle.vehicleRegistration}
                              </div>
                              <div className="tw-text-xs tw-text-gray-500">
                                {vehicle.driverName}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="tw-p-3 tw-text-center tw-text-gray-400 tw-bg-white tw-rounded tw-border tw-border-dashed">
                          {selectedTeam === "NotSubmitted"
                            ? "No submissions"
                            : "All assessments submitted"}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Not Submitted Vehicles List */}
                {(selectedTeam === "All Teams" ||
                  selectedTeam === "Submitted") && (
                  <div>
                    <div className="tw-space-y-2">
                      {showSubmitted.length > 0 ? (
                        showSubmitted.map((vehicle: any) => (
                          <div
                            key={vehicle.vehicleID}
                            className="tw-p-2 tw-bg-white tw-rounded tw-shadow-xs tw-border tw-border-green-100 tw-flex tw-justify-between tw-items-center tw-min-h-[48px]"
                          >
                            <div>
                              <div className="tw-font-medium tw-text-gray-800">
                                {vehicle.vehicleRegistration}
                              </div>
                              <div className="tw-text-xs tw-text-gray-500">
                                {vehicle.driverName}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="tw-p-3 tw-text-center tw-text-gray-400 tw-bg-white tw-rounded tw-border tw-border-dashed">
                          {selectedTeam === "Submitted"
                            ? "No submissions yet"
                            : "No pending submissions"}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default VehicleAssessmentDashboard;
